
import React, { useState, useEffect } from "react";
import { ResponsiveBullet } from "@nivo/bullet";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ReferenceLine,
  Tooltip,
  LabelList,

  CartesianGrid,
  Legend,
} from "recharts";
import { ccColorDarkTeal, ccColorLightTeal, ccColorOrange, ccColorSecondaryBronze, ccColorSecondaryGreen, ccColorSecondaryPink, ccColorSecondaryPurple, ccColorTeal } from "../components/helpersStyles";

const MARGIN = { top: 20, right: 40, bottom: 20, left: 40 };

export  function PercentageBulletChart({
  value = 30,
  recommendedLow = 20,
  recommendedHigh = 70,
}) {
  const data = [
    {
      name: "Percentage",
      before: recommendedLow,                       // gray before band
      band: recommendedHigh - recommendedLow,       // green band
      after: 100 - recommendedHigh,                 // gray after band
    },
  ];

  return (
    <div style={{ width: "100%", height: 120 }}>
      <ResponsiveContainer>
        <BarChart data={data} layout="vertical" margin={MARGIN}>
          <XAxis type="number" domain={[0, 100]} 
                  tick={{fill: ccColorDarkTeal,  fontSize: 16,}}
          />
          <YAxis type="category" dataKey="name" hide />

          {/* gray before band */}
          <Bar dataKey="before" stackId="a" fill={ccColorLightTeal} barSize={20} radius={[10, 0, 0, 10]} isAnimationActive={false} />
          {/* green band */}
          <Bar dataKey="band" stackId="a" fill={ccColorSecondaryGreen} barSize={20} isAnimationActive={false} />
          {/* gray after band */}
          <Bar dataKey="after" stackId="a" fill={ccColorLightTeal} barSize={20} radius={[0, 10, 10, 0]} isAnimationActive={false} />


          {/* Red marker line + label */}
          <ReferenceLine
            x={value}
            stroke={ccColorDarkTeal}
            strokeWidth={3}
            label={{
              value: `${value}%`,
              position: "top",
              fill: `${ccColorDarkTeal}`,
              fontSize: 12,
              fontWeight: "bold",
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export const HorizontalStackedBarChart = ({numTextLink, numImageLinks}) => {
  const [data, setData] = useState([{ name: 'links', value1: 0, value2: 0 },])

  const CustomLabel = (props) => {
  const { x, y, width, height, value, payload, dataKey } = props;
  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize={16}
    >
      {value}
    </text>
  );
};

  useEffect(() => {
    if (numImageLinks && numTextLink) {
      const newData = [{ name: 'links', value1: numImageLinks, value2: numTextLink },]
      setData(newData)
    }
  }, [numImageLinks, numTextLink])
  return (
    <ResponsiveContainer width="100%" height={60}>
      <BarChart
        layout="vertical" // Important for horizontal bars
        data={data}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis type="number" domain={[0, 'dataMax']} height={0} />
        <YAxis type="category" dataKey="name" tick={false} width={0} />
        <Legend />
        <Bar dataKey="value1" name="Image links" barSize={40} stackId="a" fill={ccColorSecondaryPurple} >          
          <LabelList
            dataKey="value1"
            content={(props) => <CustomLabel {...props} dataKey="value1" />}
          /></Bar>
        <Bar dataKey="value2" name="Text links" barSize={40} stackId="a" fill={ccColorSecondaryGreen} >
          <LabelList
            dataKey="value2"
            content={(props) => <CustomLabel {...props} dataKey="value2" />}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
